import router from '../router';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { accessTokenName, baseURL, tenantTokenName } from '../config';
import { message } from 'ant-design-vue';
import 'ant-design-vue/es/message/style/index.less';
import { codeMsg } from '@/enums/iam';
export function createService(url) {
  const service = axios.create({
    baseURL: url,
    // timeout: 60000
  });

  // Request interceptors
  service.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const localStorageAccessTokenName = localStorage.getItem(accessTokenName);

      if (localStorageAccessTokenName) {
        config.headers[accessTokenName] = localStorageAccessTokenName;
      }

      const localTenantTokenName =
        sessionStorage.getItem(tenantTokenName) ||
        localStorage.getItem(tenantTokenName);
      if (localTenantTokenName) {
        config.headers[tenantTokenName] = localTenantTokenName;
      }

      return config;
    },
    (error) => {
      console.log(error);
      Promise.reject(error);
    }
  );

  // Response interceptors
  service.interceptors.response.use(
    (response: AxiosResponse) => {
      const res = response.data;
      if (res.status && res.status !== 200) {
        if (res.status === 401 || res.status === 3004 || res.status === 403) {
          const path = router.currentRoute.value.fullPath;
          if (!router.currentRoute.value.query.redirect) {
            const { origin, pathname } = location;
            location.href = `${origin}${pathname}#/login?redirect=${encodeURIComponent(
              path
            )}`;
          }
        } else {
          message.error(res.message || 'Error');
        }
        return Promise.reject();
      } else if (typeof res.success === 'boolean') {
        if (!res.success) {
          message.error(codeMsg[res.code] || res.msg || 'Error');
          return Promise.reject();
        }
      }
      return response.data;
    },
    (error: AxiosError) => {
      if (error.response?.status == 403) {
        const path = router.currentRoute.value.fullPath;
        if (!router.currentRoute.value.query.redirect) {
          const { origin, pathname } = location;
          location.href = `${origin}${pathname}#/login?redirect=${encodeURIComponent(
            path
          )}`;
        }
      }

      message.error(
        codeMsg[error.response.data.code] ||
          error.response.data.msg ||
          error.message ||
          'Error'
      );
      return Promise.reject(error);
    }
  );

  return service;
}

export default createService(baseURL);
